import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/basic')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '10px', color: '#333' }}>Basic Route</h1>
      <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
        가장 기본적인 라우트입니다. 단일 경로에 매칭되며 고정된 컴포넌트를 렌더링합니다.
      </p>
      <Link to="/" style={{ color: '#0066cc' }}>← 홈으로</Link>
    </div>
  ),
});

